import { connect } from 'react-redux';
import { setNotificationsTabVisible } from '@core/actions/user';
import {
  fetchNotifications,
  setNotificationsAsRead,
} from '@core/notifications/actions';
import { navigationBarChangeButtons } from '@core/actions/navigationBar';
import {
  notifications,
  notificationTypeFilter,
} from '@core/notifications/selectors';
import changeNotificationTypeFilter from '@core/notifications/operations/changeNotificationTypeFilter.operation';
import { classRoomName } from '@core/selectors/classroom';
import { isNotificationsOpen } from '../../../selectors/routing';
import NotificationsDialog from './NotificationsDialog';
import {
  toggleNotifications,
  toggleUserProfile,
} from '../../../actions/navigation';

const mapStateToProps = (state) => {
  const classRoomId = state.classRoom.current || '';
  const currentSpaceName = classRoomId ? classRoomName(state) : '';

  return {
    classRoomId,
    currentSpaceName,
    notifications: notifications(state),
    notificationTypeFilter: notificationTypeFilter(state),
    isFetchingNotifications: state.data.isFetchingNotifications,
    open: isNotificationsOpen(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getNotifications: () => {
    dispatch(fetchNotifications());
  },
  setRead: (unreadNotifications) => {
    dispatch(setNotificationsAsRead(unreadNotifications));
  },
  customNavBar: (buttons) => {
    dispatch(navigationBarChangeButtons(buttons));
  },
  onOpenNotificationsSettings: () => {
    dispatch(setNotificationsTabVisible(true));
    dispatch(toggleNotifications());
    dispatch(toggleUserProfile());
  },
  onClose: ownProps.onClose || (() => dispatch(toggleNotifications())),
  changeNotificationTypeFilter: (notificationType) => {
    dispatch(changeNotificationTypeFilter(notificationType));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsDialog);
